import { Headset } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const BridgePage = lazyPage(() => import("./BridgePage"), "BridgePage");

export default defineModuleUi({
  key: "bridge",
  title: "Atendimento",
  domain: "relationship",
  icon: Headset,
  menu: [{ path: "/relacionamento/atendimento", label: "Atendimento", minRole: "member", icon: Headset, order: 80, keywords: "deskcomm crm lead atendimento webhook ponte hub" }],
  routes: [{ path: "/relacionamento/atendimento", element: <BridgePage />, minRole: "member" }],
});
